import React, { FC } from 'react'
import { Input, Button } from 'antd'
import styles from './index.module.less'

interface FilterCreateProps {
	onChange(value: string): void
	create(value: string): Promise<void>
	value: string
}

const AssignUser: FC<FilterCreateProps> = ({ create, value, onChange }) => {
	const onKeyUp = (e: React.KeyboardEvent): void => {
		if (e.key !== 'Enter') {
			return
		}

		create(value)
	}

	return (
		<Input.Group compact>
			<Input
				value={value}
				placeholder='Enter Subscriber Id to add'
				onKeyUp={onKeyUp}
				className={styles.filter}
				onChange={e => onChange(e.target.value)}
			/>
			<Button className={styles.filterButton} onClick={() => create(value)}>
				Add
			</Button>
		</Input.Group>
	)
}

export default AssignUser
